import moment from 'moment';
import { ItemHistorizable } from '../../shared/models/itemHistorizable';
import { StructureDto } from '../../shared/models/structure.dto';

export class OrientationDto implements ItemHistorizable {
  public id: number;
  public beginDate: Date;
  public endDate: Date;
  public structure: StructureDto;
  public reasonOrientationEnding: string;
  public beneficiaryId: number;
  public historized: boolean;

  public static fromJson(json: any): OrientationDto {
    if (!json) {
      return null;
    }
    return {
      id: json.id,
      beginDate: json.beginDate ? moment(json.beginDate).toDate() : undefined,
      endDate: json.endDate ? moment(json.endDate).toDate() : undefined,
      structure: json.structure,
      reasonOrientationEnding: json.reasonOrientationEnding,
      beneficiaryId: json.beneficiaryId,
      historized: json.historized,
    } as OrientationDto;
  }
}
